// نفس تقسيم الفترات في الخادم (services/greeting_phrases.py) حتى يتجدّد كاش المتصفح مع الفترة.
export const slotOf = (date = new Date()) => {
  const h = date.getHours();
  if (h >= 4 && h < 11) return "morning";
  if (h >= 11 && h < 16) return "noon";
  if (h >= 16 && h < 22) return "evening";
  return "night";
};

export const slotStamp = (date = new Date()) => `${slotOf(date)}${date.getDay()}`;

export const clockParams = (date = new Date()) => ({ h: date.getHours(), d: date.getDay() });
